<template>
<div class="container-fluid" > 
<div class="card border-primary ">
  <h5  class="card-header border-primary bg-primary text-white">
    <i  class="far fa-calendar-alt mr-2" aria-hidden="true"></i>
    VENDITE/CASSA ANNO SU ANNO</h5>
  <div class="card-body">

    <div v-if="spinner" class="text-center">
    <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
    </div>
    </div>
    <form class="mb-4"  v-on:submit.prevent="getData()">
    
   
    <year-select  v-bind:props="season_year" @update="setYear"></year-select>
    
  <div>

    <span><strong>PROVENIENZA VENDITA</strong></span>
    <div  v-for="(item,index) in salesFrom.items" :key="index">  
      <div class="form-check">
        <input type="radio" class="form-check-input" :id="'typeId_' + index" :value="index" v-model="salesFrom.typeId">
        <label class="form-check-label"  :for="'typeId_' + index">{{item.description}}</label>
      </div>
    </div>  

    <mp-select v-if="salesFrom.typeId==1" class="mt-2 mb-4" v-bind:props="market" @update="setMPId"></mp-select>
    <store-select v-if="salesFrom.typeId==0" v-bind:props="store"  @update="setStoreId"></store-select> 
    <hr>
  <div class="mt-3">
    <strong>TIPO ANALISI</strong>
  </div>
  <div class="form-check form-check-inline">
  <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="1" v-model="typeId" checked>
  <label class="form-check-label" for="inlineRadio1">VENDITE</label>
  </div>

<div class="form-check form-check-inline">
  <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="2" v-model="typeId">
  <label class="form-check-label" for="inlineRadio2">CASSA</label>
</div>
</div> 
    <button type="submit"  class="btn btn-primary ml-3 mt-3">
    <i class="far fa-play-circle mr-2"></i>
        ESEGUI
      <!--<span v-if="bt_spinner" class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>-->
     </button>
    </form> 

   
    <h5 class="card-title"></h5>
   
   
  
   <div class="table-responsive"> 
   <table class="table table-sm  table-bordered mt-2 mb-4 ">
    <thead>
      <tr class="table-header">
       <th v-for="(col,index) in cols" :key="index">
            <span>{{col}}</span>
       </th>     
        
      </tr>
    </thead>
    <tbody>
      <tr class="pointer" v-for="(item, index) in rows" :key="index">
        
        <td v-for="(col,index) in cols" :key="index">
            <span v-if="index < colIndex" class="form-control-plaintext text-right_">{{item[col]}}</span>
            <span :style="{color: item[col] > 2  ? 'blue' : 'black',fontWeight:item[col] > 0 ? 'bold':'normal'}"  v-else class="form-control-plaintext text-right">{{fmt1(item[col],2)}}</span>
        </td>    
       
      </tr> 
    </tbody>
   
  </table>
  </div>
  </div>

  <GChart class="mt-4"  v-if="chartData.length>0"
      type="ColumnChart"
      :data="chartData"
      :options="chartOptions"
    />    
  

</div>


</div>
</template>

<script>
import api               from "@/api";
import { mapGetters }    from 'vuex';
import { GChart }        from "vue-google-charts";
import yearSelect        from '@/components/common/YearSelect_1.vue'
import storeSelect       from '@/components/common/StoreSelect_1.vue'
import mpSelect          from '@/components/common/MPSelect.vue'
import fmt               from '@/components/mixins/fmt'
export default {
  mixins     : [fmt],
  components: {
    GChart,yearSelect,storeSelect,mpSelect
  },
  data() {
    return {

        colIndex        : 1,
        salesFrom       : {'items':[{'typeId':0,'description': 'RETAIL'},{'typeId':1 ,'description':'ONLINE'}],'typeId':0},
        market          :
        {
        Id            : 0,
        disabled      : false,
       
        optionBase    : true,
        required      : false
        },
        typeId          : 1,
        spinner         : false,
        rows            : [],
        cols            : [],
        season_year     :         
        {
        year          : 0,
        isActive      : true,
       
        optionBase    : false,
        required      : true

        },
        store             : 
        {
        Id            : 0,
        isActive      : true,
       
        optionBase    : true,
        required      : false
        },
        msg             : {

        title     : '',
        body      : '',
        type      : 0

        },
        year1     : 0,
        year2     : 0,
      
        month    : ['Gen','Feb','Mar','Apr','Mag','Giu','Lug','Ago','Set','Ott','Nov','Dic'] ,     
        chartData: [
              
      ],
      chartOptions: {

         title: '' 
          
           

      
      }
    }


  },

computed :{
    ...mapGetters(['company']),},

created: function() {

   
  },
 methods: 
  {

    setMPId(Id,e)
    {
      this.market.Id = Id
      
    },  

   
     setStoreId(storeId,e)
     {      
      this.store.Id = storeId
      
            
     },  
     setYear(year)
     {  
        this.year1 = year-1
        this.year2 = year 
        
        //this.getData(year1,year2)
     },
     async getData() 
     {

      this.cols = []
      this.rows = []
      this.spinner = true
      
      this.chartData = []

      let sp = ''

      if(this.salesFrom.typeId == 0)
      {
        this.colIndex = 1
        sp = {'sp' : this.typeId == 1 ? 'spSalesYearToYearType1' : 'spSalesYearToYearType2'}  
      }
      else
      {
        this.colIndex = 3
        sp = {'sp' : 'spSalesYearToYearWeb' }
      }  
      
     
      const data  = 
      {
        'companyId'   : this.company.Id,
        'storeId'     : this.store.Id,
        'year1'       : this.year1,
        'year2'       : this.year2,
        'mpId'        : this.market.Id
        
      }
      
      const json  = Object.assign(data, sp)      
     
      this.spinner = true

      await api.post(json).then(async res => {
         
          if(res.status==200)
            {
              
              

              let chartData = []
              let arrData = res.data.recordsets[0]               
              let total1  = 0
              let total2  = 0            
              if(arrData.length>0)
              {
                chartData   = []
                
                let arr     = ['Mese',this.year1.toString(),this.year2.toString()]
                chartData.push(arr)               
              
                let temp = []             
                arrData.forEach(item => {
                  
                  temp.push(this.month[item.mese-1])

                  if(item[this.year1])
                  {                  
                    temp.push(item[this.year1])
                    total1 += item[this.year1]
                  }
                  else
                  {
                      temp.push(0)
                  }
                  if(item[this.year2])
                  {
                    temp.push(item[this.year2])
                    total2 += item[this.year2]
                  }
                  else
                  {
                      temp.push(0)
                  }

                  chartData.push(temp)      
                  temp = []
              });

              
              this.chartData = chartData
              const text = this.typeId == 1 ? 'VENDITE ' : 'CASSA '
              this. chartOptions.title = 'TOTALE  ' + text + this.year1 + ' [ ' + this.fmt1(total1,2) + ' € ]    -    ' + this.year2 + ' [ ' + this.fmt1(total2,2) + ' € ]'

              }
            

            let data = res.data.recordsets[1]
           
            if(data.length>0)
            {
            for (let key in data[0]) {
              
              this.cols.push(key)
              
              }  
              this.rows = res.data.recordsets[1]
            }
    
             

            }
            else if (res.status==500)
            {
              

              this.msg.title = 'ATTENZIONE '
              this.msg.body  = res.data
              this.msg.type  = 1
              
            }
          
          else
          {

           
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = res
            this.msg.type  = 1
                        

          }
      }).catch(err=>{
        
            
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = err.message
            this.msg.type  = 1
        

      }).finally(() => {
          this.spinner = false
        });
      

    },
   
  }

};
</script>
<style scoped>
.table-header{
  background-color: hwb(45 4% 9%)  !important;
}


.form-check-label{
  cursor:pointer
}
</style>
